export default {
    makeIds: 'make',
    modelIds: 'model',
    exteriorColorIds: 'exteriorColors',
    fuelTypes: 'fuelTypes',
    transmissionTypes: 'transmissionTypes',
    drivetrains: 'drivetrains',
    yearRange: 'yearRange',
    salePriceRange: 'salePriceRange',
    frameStyleTypes: 'frameStyleTypes',
    odometerRange: 'odometer',
};
